<div class="modal-content bg-white" style="height: 100vh; overflow-y: auto;">
  <div class="modal-wrapper">
    <div class="modal-header border-0 position-relative">

      <button type="button" class="btn-close me-3" aria-label="Close" (click)="onCancelClick()"></button>

      <div class="modal-title w-100 border-0 mt-5" id="myModalLabel">
        <div class="d-flex justify-content-between">
          <div class="">
            <small class="grey-muted footer-text">
              {{userPersistenceService.generalTranslation.UploadSupportingDocuments}}
            </small><br>
            <h5 class="modal-title w-100 border-0" id="myModalLabel">
              {{title}}
            </h5>
          </div>
          <div class="">
            <small class="grey-muted footer-text">
              {{projDocUpload.projectData.masterProjectName}}
            </small><br>
            <h5 class="text-headergrey">{{projDocUpload.projectData.projectName}}</h5>
          </div>
        </div>
      </div>
    </div>
@if (wallWarningMessages.length > 0) {
        <div class="modal-warning-banner">
          @for (msg of wallWarningMessages; track msg) {
            <div class="alert alert-warning mb-0 py-2">
              {{ msg }}
            </div>
          }
        </div>
      }
    <div class="modal-body">
      <div class="measure-project-tabs">
        <mat-tab-group class="classic-tabs tabs-ifc-edge" (selectedTabChange)="onTabChange($event)">
          <!--Panel 1-->
          <mat-tab>
            <ng-template mat-tab-label><span [ngClass]="projectLevelAllApproved && showApprovedTicks ? 'd-inline-block' : 'd-inline-block opacity-0'"><i class='material-icons tick-green text-green'>check_circle_outline</i></span><div><span>Project Level</span></div></ng-template>
            <ifc-project-document-comment [projDocUpload]="projDocUpload" [showEEM27]="showEEM27" (onProjectUploadTickerChange)="updateProjectHeaderTicker($event)"></ifc-project-document-comment>
          </mat-tab>

          @if (!hideOnclose && showDesignTab) {
            <mat-tab label="designpost">
              <ng-template mat-tab-label><span [ngClass]="designLevelAllApproved && showApprovedTicks ? 'd-inline-block' : 'd-inline-block opacity-0'"><i class='material-icons tick-green text-green'>check_circle_outline</i></span><div><span>{{designHeading}}</span></div></ng-template>
              <mat-accordion class="accordion" [multi]="true">
                <!-- Project Decision [START]-->
                @if ((fileAccess.canViewComment || fileAccess.canSendForAudit) && projectData.showProjectDecision) {
                  <mat-expansion-panel [expanded]="true"
                    >
                    <mat-expansion-panel-header>
                      <mat-panel-title>{{userPersistenceService.generalTranslation.ProjectDecision}}</mat-panel-title>
                    </mat-expansion-panel-header>
                    @if (!fileAccess.canSendForAudit) {
                      <p class="body2 text-black-opacity-point6 text-break">
                        {{userPersistenceService.generalTranslation.ProjectDecisionMessage}}
                      </p>
                    }
                    @if (fileAccess.canSendForAudit) {
                      <p class="body2 text-black-opacity-point6 text-break">
                        {{ projectData.projectStage == 'Preliminary' ? userPersistenceService.generalTranslation.SendProjForAuditDecision : userPersistenceService.generalTranslation.SendProjForPostAuditDecision}}
                      </p>
                    }
                    @if (fileAccess.canSendForAudit) {
                      <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons"
                        >
                        <button id="btn" type="button" mat-raised-button color="primary"
                          class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                          (click)="sendForAudit()"
                          [disabled]="false">
                          {{ projectData.projectStage == 'Preliminary' ? userPersistenceService.generalTranslation.SendProjForAudit : userPersistenceService.generalTranslation.SendProjForPostAudit}}
                        </button>
                      </div>
                    }
                    @if (projectData.projectStatus == projectStatus.ProjectUnderReview) {
                      <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons gap-2"
                        >
                        <button id="btn" type="button" mat-stroked-button color="primary"
                          class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                          (click)="approveOrRejectProject(projectApprovalStatus.rejectedAndSendToCA)"
                          [disabled]="false">
                          {{userPersistenceService.generalTranslation.RejectAndSendToCertifier}}
                        </button>
                        <button id="btn" type="button" mat-stroked-button color="primary"
                          class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                          (click)="approveOrRejectProject(projectApprovalStatus.rejected)" [disabled]="false">
                          {{userPersistenceService.generalTranslation.RejectAndSendToAuditor}}
                        </button>
                        @if ($any(fileAccess).showApproveRef) {
                          <br>
                          }
                          @if ($any(fileAccess).showApproveRef) {
                            <button id="btn" type="button" mat-stroked-button color="primary"
                              class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                              (click)="approveThroughReferenceClick()" [disabled]="false">
                              {{userPersistenceService.generalTranslation.ApproveByRef}}
                            </button>
                          }
                          <button id="btn" type="button" mat-raised-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                            (click)="approveOrRejectProject(projectApprovalStatus.approved)" [disabled]="false">
                            {{userPersistenceService.generalTranslation.ApproveAndSendToCertifier}}
                          </button>
                        </div>
                      }
                      @if (projectData.projectStatus !== projectStatus.ProjectUnderReview && role !== 'Client') {
                        <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons gap-2"
                          >
                          <button id="btn" type="button" mat-stroked-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                            (click)="approveOrRejectProject(projectApprovalStatus.rejected)" [disabled]="false">
                            {{userPersistenceService.generalTranslation.Reject}}
                          </button>
                          @if ($any(fileAccess).showApproveRef) {
                            <button id="btn" type="button" mat-stroked-button color="primary"
                              class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                              (click)="approveThroughReferenceClick()" [disabled]="fileAccess.disableCAApproveButton">
                              {{userPersistenceService.generalTranslation.ApproveByRef}}
                            </button>
                          }
                          <button id="btn" type="button" mat-raised-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                            (click)="approveOrRejectProject(projectApprovalStatus.approved)"
                            [disabled]="fileAccess.disableCAApproveButton">
                            {{userPersistenceService.generalTranslation.Approve}}
                          </button>
                        </div>
                      }
                    </mat-expansion-panel>
                  }
                  <!-- Project Decision [END]-->
                </mat-accordion>
                @if (designValidationMsg !== '') {
                  <div class="warningforsubprojects mt-2">
                    <div [ngClass]="isApprove?'alert alert-danger':'alert alert-warning'" role="alert">
                      {{designValidationMsg}}
                    </div>
                  </div>
                }
                <div class="leveltype-cols mt-4">
                  <div class="row">
                    <div class="col-12 col-md-3 pe-md-4 leveltype-menu-col">
                      <div class="list-group">
                        @for (design of designLevelList; track design; let i = $index) {
                          <div>
                            <div class="d-flex">
                              <a href="javascript:void(0)" (click)="showDesignLevelDocUpload(design.measureId, i, $event)"
                                class="list-group-item list-group-item-action"
                                [class.active]="designActiveIndex === i">
                                @if (showStatusDots) {
                                  <span>
                                    @if (design.status === 0) {
                                      <span class="grid-cell-notification me-1">
                                        <i style="font-size:10px" class="fas fa-circle text-buttercup">
                                        </i>
                                      </span>
                                    }
                                    @if (design.status === 2) {
                                      <span class="grid-cell-notification me-1">
                                        <i style="font-size:10px" class="fas fa-circle text-red">
                                        </i>
                                      </span>
                                    }
                                  </span>
                                }
                                {{design.value}}
                                @if (design.approved != false && showApprovedTicks) {
                                  <span class="uploadedTick">
                                    <i class="fas fa-check text-green"></i>
                                  </span>
                                }
                              </a>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-9 ps-md-4 leveltype-content-col">
                      <div class="upload-level-data">
                        @if (selectedDesignMeasure) {
                          <div>
                            <ifc-design-document-comment #designDocumentCommentComponent
                              [projDocUpload]="projDocUploadDesign"
                              (fileUploadSuccessEmit)="designLevelFileUploadSuccess($event)">
                            </ifc-design-document-comment>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            }

            @if (bshowpriliminary && !hideOnclose && showDesignTabPrelim) {
              <mat-tab label="designprelim">
                <ng-template mat-tab-label><span [ngClass]="showApprovedTicks ? 'd-inline-block' : 'd-inline-block opacity-0'"><i class='material-icons tick-green text-green'>check_circle_outline</i></span><div><span>{{designPrelimHeading}}</span></div></ng-template>
                <div class="leveltype-cols mt-4">
                  <div class="row">
                    <div class="col-12 col-md-3 pe-md-4 leveltype-menu-col">
                      <div class="list-group">
                        @for (design of designLevelListPrelim; track design; let i = $index) {
                          <div>
                            <div class="d-flex">
                              <a href="javascript:void(0)" (click)="showDesignLevelPelimDocUpload(design.measureId, i, $event)"
                                class="list-group-item list-group-item-action"
                                [class.active]="designActiveprelimIndex === i">
                                {{design.value}}
                                @if (design.approved != false && showApprovedTicks) {
                                  <span class="uploadedTick">
                                    <i class="fas fa-check text-green"></i>
                                  </span>
                                }
                              </a>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-9 ps-md-4 leveltype-content-col">
                      <div class="upload-level-data">
                        @if (selectedDesignMeasurePrelim) {
                          <div>
                            <ifc-design-document-commentprelim #designDocumentCommentComponentprelim
                              [projDocUpload]="projDocUploadDesignPrelim"
                                [showComments]="showComments"
                              (fileUploadSuccessEmit)="designLevelFileUploadPrelimSuccess($event)">
                            </ifc-design-document-commentprelim>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            }

            <!--Panel 2-->
            @if (!hideOnclose) {
              <mat-tab label="measurepost">
                <ng-template mat-tab-label><span [ngClass]="measureLevelAllApproved && showApprovedTicks ? 'd-inline-block' : 'd-inline-block opacity-0'"><i class='material-icons tick-green text-green'>check_circle_outline</i></span><div><span>{{headingtxt}}</span></div></ng-template>
                <mat-accordion class="accordion" [multi]="true">
                  <!-- Project Decision [START]-->
                  @if ((fileAccess.canViewComment || fileAccess.canSendForAudit) && projectData.showProjectDecision) {
                    <mat-expansion-panel [expanded]="true"
                      >
                      <mat-expansion-panel-header>
                        <mat-panel-title>{{userPersistenceService.generalTranslation.ProjectDecision}}</mat-panel-title>
                      </mat-expansion-panel-header>
                      @if (!fileAccess.canSendForAudit) {
                        <p class="body2 text-black-opacity-point6 text-break">
                          {{userPersistenceService.generalTranslation.ProjectDecisionMessage}}
                        </p>
                      }
                      @if (fileAccess.canSendForAudit) {
                        <p class="body2 text-black-opacity-point6 text-break">
                          {{ projectData.projectStage == 'Preliminary' ? userPersistenceService.generalTranslation.SendProjForAuditDecision : userPersistenceService.generalTranslation.SendProjForPostAuditDecision}}
                        </p>
                      }
                      @if (fileAccess.canSendForAudit) {
                        <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons"
                          >
                          <button id="btn" type="button" mat-raised-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                            (click)="sendForAudit()"
                            [disabled]="false">
                            {{ projectData.projectStage == 'Preliminary' ? userPersistenceService.generalTranslation.SendProjForAudit : userPersistenceService.generalTranslation.SendProjForPostAudit}}
                          </button>
                        </div>
                      }
                      @if (projectData.projectStatus == projectStatus.ProjectUnderReview) {
                        <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons gap-2"
                          >
                          <button id="btn" type="button" mat-stroked-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                            (click)="approveOrRejectProject(projectApprovalStatus.rejectedAndSendToCA)"
                            [disabled]="false">
                            {{userPersistenceService.generalTranslation.RejectAndSendToCertifier}}
                          </button>
                          <button id="btn" type="button" mat-stroked-button color="primary"
                            class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                            (click)="approveOrRejectProject(projectApprovalStatus.rejected)" [disabled]="false">
                            {{userPersistenceService.generalTranslation.RejectAndSendToAuditor}}
                          </button>
                          @if ($any(fileAccess).showApproveRef) {
                            <br>
                            }
                            @if ($any(fileAccess).showApproveRef) {
                              <button id="btn" type="button" mat-stroked-button color="primary"
                                class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                                (click)="approveThroughReferenceClick()" [disabled]="false">
                                 {{userPersistenceService.generalTranslation.ApproveByRef}}
                            </button>
                            }
                            <button id="btn" type="button" mat-raised-button color="primary"
                              class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded w-300px"
                              (click)="approveOrRejectProject(projectApprovalStatus.approved)" [disabled]="false">
                              {{userPersistenceService.generalTranslation.ApproveAndSendToCertifier}}
                            </button>
                          </div>
                        }
                        @if (projectData.projectStatus !== projectStatus.ProjectUnderReview && role !== 'Client') {
                          <div class="w-100 text-end me-0 mt-2 mb-2 pb-0 colButtons gap-2"
                            >
                            <button id="btn" type="button" mat-stroked-button color="primary"
                              class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                              (click)="approveOrRejectProject(projectApprovalStatus.rejected)" [disabled]="false">
                              {{userPersistenceService.generalTranslation.Reject}}
                            </button>
                            @if ($any(fileAccess).showApproveRef) {
                              <button id="btn" type="button" mat-stroked-button color="primary"
                                class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                                (click)="approveThroughReferenceClick()" [disabled]="fileAccess.disableCAApproveButton">
                                {{userPersistenceService.generalTranslation.ApproveByRef}}
                              </button>
                            }
                            <button id="btn" type="button" mat-raised-button color="primary"
                              class="text-uppercase pt-2 pb-2 me-0 no-shadow rounded"
                              (click)="approveOrRejectProject(projectApprovalStatus.approved)"
                              [disabled]="fileAccess.disableCAApproveButton">
                              {{userPersistenceService.generalTranslation.Approve}}
                            </button>
                          </div>
                        }
                      </mat-expansion-panel>
                    }
                    <!-- Project Decision [END]-->
                  </mat-accordion>
                  @if (validationMsg !== '') {
                    <div class="warningforsubprojects mt-2">
                      <div [ngClass]="isApprove?'alert alert-danger':'alert alert-warning'" role="alert">
                        {{validationMsg}}
                      </div>
                    </div>
                  }
                  <div class="leveltype-cols mt-4">
                    <div class="row">
                      <div class="col-12 col-md-3 pe-md-4 leveltype-menu-col">
                        <div class="list-group">
                          @for (errorMsg of measureLevelError; track errorMsg; let i = $index) {
                            <div>
                              <div class="d-flex">
                                <a href="javascript:void(0)" (click)="showMeasureLevelDocUpload(errorMsg.measureId, i, $event)"
                                  class="list-group-item list-group-item-action"
                                  [class.active]="sIndex === i">
                                  @if (showStatusDots) {
                                    <span>
                                      @if (errorMsg.status === 0) {
                                        <span class="grid-cell-notification me-1">
                                          <i style="font-size:10px" class="fas fa-circle text-buttercup">
                                          </i>
                                        </span>
                                      }
                                      @if (errorMsg.status === 2) {
                                        <span class="grid-cell-notification me-1">
                                          <i style="font-size:10px" class="fas fa-circle text-red">
                                          </i>
                                        </span>
                                      }
                                    </span>
                                  }
                                  {{errorMsg.value}}
                                  @if (errorMsg.approved != false && showApprovedTicks) {
                                    <span class="uploadedTick">
                                      <i class="fas fa-check text-green"></i>
                                    </span>
                                  }
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-12 col-md-9 ps-md-4 leveltype-content-col">
                        <div class="upload-level-data">
                          @if (selectedmeasure) {
                            <div>
                              <ifc-measure-document-comment #measureDocumentCommentComponent
                                [projDocUpload]="projDocUpload"
                                  [eem08ValidationMessageFromModal]="wallEem08Message"
                                  [eem09ValidationMessageFromModal]="wallEem09Message"
                                (fileUploadSuccessEmit)="measureLevelFileUploadSuccess($event)">
                              </ifc-measure-document-comment>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              }

              @if (bshowpriliminary && !hideOnclose) {
                <mat-tab label="measureprelim">
                  <ng-template mat-tab-label><span [ngClass]="showApprovedTicks ? 'd-inline-block' : 'd-inline-block opacity-0'"><i class='material-icons tick-green text-green'>check_circle_outline</i></span><div><span>{{headingprelim}}</span></div></ng-template>
                  <div class="leveltype-cols mt-4">
                    <div class="row">
                      <div class="col-12 col-md-3 pe-md-4 leveltype-menu-col">
                        <div class="list-group">
                          @for (errorMsg1 of measureLevelErrorPrelim; track errorMsg1; let i = $index) {
                            <div>
                              <div class="d-flex">
                                <a href="javascript:void(0)" (click)="showMeasureLevelPelimDocUpload(errorMsg1.measureId, i, $event)"
                                  class="list-group-item list-group-item-action"
                                  [class.active]="pIndex === i">
                                  {{errorMsg1.value}}
                                  @if (errorMsg1.approved != false && showApprovedTicks) {
                                    <span class="uploadedTick">
                                      <i class="fas fa-check text-green"></i>
                                    </span>
                                  }
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                      <div class="col-12 col-md-9 ps-md-4 leveltype-content-col">
                        <div class="upload-level-data">
                          @if (selectedmeasurePrelim) {
                            <div>
                              <ifc-measure-document-commentprelim #measureDocumentCommentComponentprelim
                                [projDocUpload]="projDocUploadPrelim"
                                 [showComments]="showComments"
                                (fileUploadSuccessEmit)="measureLevelFileUploadPrelimSuccess($event)">
                              </ifc-measure-document-commentprelim>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-tab>
              }
            </mat-tab-group>
          </div>
        </div>
      </div>
    </div>
